<template>
	<div class="view-index-v" v-if="mediaLength" :style="{'--img-count': mediaLength}">
		<div class="rotation-poster">
			<div class="container" :style="{top: swiper.offset, transition: `${swiper.ition}s`}">
				<template v-for="(item, idx) in settingData.mediaLst">
					<div class="img-item" v-if="item.videoUrlV" :key="idx" @click="onPosterClick(item)"
						:style="{backgroundImage: 'url('+item.coverUrlV+')'}">
						<video :id="`poster-video-player${idx}`" muted :autoplay="false" 
							@ended="onVideoEnded(idx)">
							<source :src="item.videoUrlV" type="video/mp4" />
						</video>
					</div>
					<img class="img-item" v-else :src="item.coverUrlV" :key="idx"
						 alt="" @click="onPosterClick(item)">
				</template>
			</div>
			<div class="menu-list">
				<div class="menu-item single-line" v-for="(item, idx) in settingData.mediaLst" :key="idx"
					:class="{'actived': swiper.imgShow == idx}" @click="onclickMenuClick(idx)"
					:style="{top: (100 * idx) + 'px' }">
					{{item.linkTxt}}
				</div>
				<img class="menu-item-bg" src="~@/assets/left-menu-bg.png" :style="itemBgStyle" />
			</div>
		</div>
		<div class="inline-column-left cat-list">
			<div class="inline-between cat-item" v-for="(item, idx) in listData" :key="idx">
				<div class="line"></div>
				<div class="content">
					<div class="inline-column-left main-container">
						<div class="cat-name">{{item.categoryName}}</div>
						<div class="product-list">
							<div v-if="item.productServiceList.length == 0">
								暂无产品服务
							</div>
							<template v-else>
								<span v-for="(product,idx2) in item.productServiceList" :key="idx2"
									@click="onClickItem(product.id)">{{product.productName}}</span>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		mapGetters
	} from 'vuex'
	import IndexMixin from './mixins/index.js';
	export default {
		name: 'IndexV',
		mixins: [IndexMixin],
		components: {
	
		},
		data() {
			return {
				
			}
		},
		watch:{
		  scaleRate: {
		    handler(val,oldValue) {
				let doms = document.getElementsByClassName('cat-item');
				this.$nextTick(() => {
					for(let i = 0; i < doms.length; i ++) {
						doms[i].getElementsByClassName('content')[0].style.height =
							(doms[i].getElementsByClassName('main-container')[0].getBoundingClientRect().height) + 'px';
					}
				});
		    },
		    //立刻执行handler
		    //immediate: true
		  }
		},
		computed: {
			...mapGetters(["scaleRate"]),
			itemBgStyle() {
				return {
					top: (100 * this.swiper.imgShow) + 'px'
				}
			},
		},
		methods: {
			onProductCatLoaded() {
				this.$nextTick(() => {
					let doms = document.getElementsByClassName('cat-item');
					for(let i = 0; i < doms.length; i ++) {
						doms[i].getElementsByClassName('content')[0].style.height = 
							(doms[i].getElementsByClassName('main-container')[0].getBoundingClientRect().height) + 'px';
					}
				});
			}
		}
	}
</script>
<style scoped lang="less">
	.view-index-v {
		width: 100%;
		padding: 0 calc(52px * var(--scale-rate));
		
		.rotation-poster {
			width: 100%;
			height: 0;
			padding-top: 56.25%;
			position: relative;
			overflow: hidden;
		
			.container {
				width: 100%;
				height: calc(100% * var(--img-count));
				top: 0;
				overflow: hidden;
				position: absolute;
				/* 开启弹性盒，让图片横向排列 */
				display: flex;
				flex-direction: column;
				animation: run 10s ease infinite;
			}
		
			.img-item {
				width: 100%;
				height: calc(100% / var(--img-count));
				cursor: pointer;
				video {
					width: 100%;
					height: 100%;
				}
			}
			div .img-item {
				background-size: cover;
				background-color: #000000;
			}
			
			.menu-list {
				position: absolute;
				z-index: 99;
				right: 0;
				top: 0;
				width: calc(33% / var(--scale-rate));
				height: calc(100% / var(--scale-rate));
				background-color: rgba(230, 230, 230, 31%);
				overflow-y: auto;
				transform: scale(var(--scale-rate));
				transform-origin: 100% 0;
				backdrop-filter: blur(3px);
				
				&::-webkit-scrollbar {
					display: none;
				}
				.menu-item {
					position: absolute;
					cursor: pointer;
					line-height: 100px;
					width: calc(100% - 40px);
					height: 100px;
					margin: auto 20px;
					font-size: 36px;
					color: rgba(255, 255, 255, 1);
					font-weight: lighter;
					z-index: 99;
					text-shadow:2px 2px 2px rgba(0, 0, 0, 1);
					
					&.actived {
						font-weight: normal;
						text-shadow:2px 2px 2px rgba(0, 0, 0, 1);
					}
				}
				
				.menu-item-bg {
					width: 100%;
					height: 100px;
					object-fit: fill;
					position: absolute;
					z-index: 0;
					transition: 0.2s;
					z-index: 0;
				}
			}
		
		}
		
		.cat-list {
			margin-top: calc(45px * var(--scale-rate));
			width: 100%;
			.cat-item {
				width: 100%;
				padding: calc(30px * var(--scale-rate)) 0;
				.line {
					background-color: rgb(17, 74, 117);
					width: calc(9px * var(--scale-rate));
					height: calc(75px * var(--scale-rate));
				}
				.content {
					margin-left: calc(34px * var(--scale-rate));
					flex: 1;
				}
				.main-container {
					width: calc(100% / var(--scale-rate));
					transform: scale(var(--scale-rate));
					transform-origin: left top;
					display:inline-block;
					
					.cat-name {
						width: 100%;
						font-size: 46px;
						color: rgb(29, 41, 116); 
						display:inline-block;
					}
					.product-list {
						margin-top: 5px;
						width: 100%;
						font-size: 32px;
						display:inline-block;
						span {
							cursor: pointer;
						}
						span:not(:first-child) {
							margin-left: 30px;
						}
					}
				}
			}
		}
		
	}
</style>